import { render, staticRenderFns } from "./nameAndIdentitycard.vue?vue&type=template&id=755c9ccc&scoped=true"
import script from "./nameAndIdentitycard.vue?vue&type=script&lang=js"
export * from "./nameAndIdentitycard.vue?vue&type=script&lang=js"
import style0 from "./nameAndIdentitycard.vue?vue&type=style&index=0&id=755c9ccc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c9ccc",
  null
  
)

export default component.exports